import { ScrollingModule } from "@angular/cdk/scrolling";
import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatLineModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterModule } from "@angular/router";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { TranslateModule } from "@ngx-translate/core";
import { NgBottomNavigationModule } from "ng-bottom-navigation";
import { NgxMaskModule } from "ngx-mask";
import { MomentModule } from "ngx-moment";
import { NgxSpinnerModule } from "ngx-spinner";
import { BackButtonComponent } from "src/app/shared/component/back-button/back-button.component";
import { CertificateViewerModule } from "src/app/shared/component/certificate-viewer/certificate-viewer.module";
import { NgCreditCardModule } from "src/app/shared/component/ng-credit-card/ng-credit-card.module";
import { SharedModule } from "src/app/shared/shared.module";
import { LeaderboardModule } from "../../shared/component/leaderboard/leaderboard.module";
import { ProfileAboutUsComponent } from "./page/profile-about-us/profile-about-us.component";
import { ProfileAccountComponent } from "./page/profile-account/profile-account.component";
import { ProfileAchievementsComponent } from "./page/profile-achievements/profile-achievements.component";
import { CancelBillComponent } from "./page/profile-billing/components/cancel-bill/cancel-bill.component";
import { ProfileBillingComponent } from "./page/profile-billing/profile-billing.component";
import { ProfileCertificatesComponent } from "./page/profile-certificates/profile-certificates.component";
import { ProfileChangeEmailComponent } from "./page/profile-change-email/profile-change-email.component";
import { ProfileChangePasswordComponent } from "./page/profile-change-password/profile-change-password.component";
import { ProfileContactUsComponent } from "./page/profile-contact-us/profile-contact-us.component";
import { ProfileDocumentsComponent } from "./page/profile-documents/profile-documents.component";
import { ProfileFaqComponent } from "./page/profile-faq/profile-faq.component";
import { ProfileInterestsComponent } from "./page/profile-interests/profile-interests.component";
import { ProfileLeaderboardComponent } from "./page/profile-leaderboard/profile-leaderboard.component";
import { ProfilePaymentMethodsComponent } from "./page/profile-payment-methods/profile-payment-methods.component";
import { ProfilePreferencesComponent } from "./page/profile-preferences/profile-preferences.component";
import { ProfilePrivacyPolicyComponent } from "./page/profile-privacy-policy/profile-privacy-policy.component";
import { CancelRecurrenceSubscriptionComponent } from "./page/profile-recurrence-subscriptions/components/cancel-recurrence-subscription/cancel-recurrence-subscription.component";
import { ProfileRecurrenceSubscriptionsComponent } from "./page/profile-recurrence-subscriptions/profile-recurrence-subscriptions.component";
import { ProfileReviewListComponent } from "./page/profile-review-list/profile-review-list.component";
import { ProfileSkillsComponent } from "./page/profile-skills/profile-skills.component";
import { ProfileUseTermsComponent } from "./page/profile-use-terms/profile-use-terms.component";
import { ProfileComponent } from "./page/profile.component";
import { ProfileRoutingModule } from "./profile.routing";

@NgModule({
    declarations: [
        ProfileAccountComponent,
        ProfileChangeEmailComponent,
        ProfileChangePasswordComponent,
        ProfileInterestsComponent,
        ProfileFaqComponent,
        ProfileContactUsComponent,
        ProfileUseTermsComponent,
        ProfileAboutUsComponent,
        ProfilePreferencesComponent,
        ProfileReviewListComponent,
        ProfilePrivacyPolicyComponent,
        ProfileComponent,
        ProfileDocumentsComponent,
        ProfileAchievementsComponent,
        ProfileSkillsComponent,
        ProfileBillingComponent,
        CancelBillComponent,
        ProfileRecurrenceSubscriptionsComponent,
        CancelRecurrenceSubscriptionComponent,
        ProfileLeaderboardComponent,
        ProfileCertificatesComponent,
        ProfilePaymentMethodsComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        ProfileRoutingModule,
        NgBottomNavigationModule,
        MatToolbarModule,
        MatCardModule,
        MatBadgeModule,
        MatChipsModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatLineModule,
        MatListModule,
        MatExpansionModule,
        MatSelectModule,
        FormsModule,
        MatInputModule,
        MatSlideToggleModule,
        MatDividerModule,
        MatMenuModule,
        MatGridListModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        TextFieldModule,
        ScrollingModule,
        HttpClientModule,
        AngularEditorModule,
        TranslateModule,
        MomentModule,
        FlexLayoutModule,
        MatDialogModule,
        NgxMaskModule.forRoot(),
        LeaderboardModule,
        MatTabsModule,
        NgxSpinnerModule,
        MatTableModule,
        CertificateViewerModule,
        NgCreditCardModule,

        BackButtonComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProfileModule {}
